import PROFILE_SECTIONS from "PFApp/profiles/profile_sections";
import { customTypesAccessLevelsAgainstProfile, hasCustomTypeSection } from "PFCore/helpers/custom_types";
import { CurrentProfile, CustomType, Profile } from "PFTypes";

const hasRequiredPermissionsData = (
  profile: Profile | null | undefined,
  currentProfile: CurrentProfile | null | undefined,
  customTypes: CustomType[] | undefined
) => [currentProfile?.permissionsGroup, profile?.permissionsGroup, customTypes?.length].every(Boolean);

const isCustomTypeVisible = (
  ct: CustomType | undefined,
  accessLevels: Record<number, unknown>,
  isMe: boolean
): ct is CustomType => {
  if (!ct || !accessLevels[ct.id]) {
    return false;
  }
  return isMe || !hasCustomTypeSection(ct, PROFILE_SECTIONS.profile_private_fields);
};

export const getVisibleCustomTypes = (
  profile: Profile | null | undefined,
  currentProfile: CurrentProfile | null | undefined,
  customTypes: CustomType[] | undefined,
  only?: string[]
): CustomType[] => {
  if (!hasRequiredPermissionsData(profile, currentProfile, customTypes)) {
    return [];
  }

  const accessLevels = customTypesAccessLevelsAgainstProfile(profile!, currentProfile!);
  const isMe = currentProfile!.id === profile!.id;
  const candidates = (only || []).map((ct) => customTypes?.find(({ name }) => name === ct));

  return candidates.filter((ct) => isCustomTypeVisible(ct, accessLevels, isMe));
};
